
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class SetPassword extends Vue {
  public readonly visible = false
  @Prop({ type: Array, default: () => [] })
  public readonly rules!: any[]
}
